import { careerProfileLabels } from "../../../Types/careerProfileLabels"
import PastEducationExperiencesRadioBtn from "../PastEducationExperiences/PastEducationExperiencesRadioBtn"
import styles from "../../../../../styles/Participant-Employment.module.css"
import RadioButtonField from "../../../Utils/RadioButtonField"
import EditorField from "../../../Utils/EditorField"
import PastEducationExperiencesCheckboxForm from "./PastEducationExperiencesCheckboxForm"
import TextField from "../../../Utils/TextField"

const PastEducationExperiences = ({ formik }) => {
  return (
    <>
      <label className={`${styles.label}`} style={{ marginBottom: "20px" }}>
        Please select whether the following topics were either favorable or you
        had a problem with.
      </label>
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_1.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_1.value
        }
        value={formik.values.pastEducation_1}
        callback={() => {
          if (formik.values.pastEducation_1 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_1a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_1 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_1a
                .label
            }
            value={formik.values.pastEducation_1a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_1a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_2.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_2.value
        }
        value={formik.values.pastEducation_2}
        callback={() => {
          if (formik.values.pastEducation_2 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_2a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_2 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_2a
                .label
            }
            value={formik.values.pastEducation_2a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_2a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_3.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_3.value
        }
        value={formik.values.pastEducation_3}
        callback={() => {
          if (formik.values.pastEducation_3 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_3a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_3 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_3a
                .label
            }
            value={formik.values.pastEducation_3a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_3a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_4.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_4.value
        }
        value={formik.values.pastEducation_4}
        callback={() => {
          if (formik.values.pastEducation_4 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_4a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_4 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_4a
                .label
            }
            value={formik.values.pastEducation_4a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_4a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_5.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_5.value
        }
        value={formik.values.pastEducation_5}
        callback={() => {
          if (formik.values.pastEducation_5 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_5a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_5 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_5a
                .label
            }
            value={formik.values.pastEducation_5a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_5a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_6.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_6.value
        }
        value={formik.values.pastEducation_6}
        callback={() => {
          if (formik.values.pastEducation_6 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_6a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_6 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_6a
                .label
            }
            value={formik.values.pastEducation_6a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_6a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_7.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_7.value
        }
        value={formik.values.pastEducation_7}
        callback={() => {
          if (formik.values.pastEducation_7 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_7a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_7 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_7a
                .label
            }
            value={formik.values.pastEducation_7a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_7a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_8.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_8.value
        }
        value={formik.values.pastEducation_8}
        callback={() => {
          if (formik.values.pastEducation_8 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_8a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_8 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_8a
                .label
            }
            value={formik.values.pastEducation_8a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_8a
                .value
            }
          />
        </div>
      )}
      <PastEducationExperiencesRadioBtn
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_9.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_9.value
        }
        value={formik.values.pastEducation_9}
        callback={() => {
          if (formik.values.pastEducation_9 !== "Problem") {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_9a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_9 === "Problem" && (
        <div style={{ marginBottom: "10px" }}>
          <TextField
            size={50}
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_9a
                .label
            }
            value={formik.values.pastEducation_9a}
            setValue={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_9a
                .value
            }
          />
        </div>
      )}
      <RadioButtonField
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_10.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_10.value
        }
        value={formik.values.pastEducation_10}
        callback={() => {
          formik.setFieldValue(
            careerProfileLabels.pastEducationExperiences.pastEducation_10a
              .value,
            undefined
          )
          formik.setFieldValue(
            careerProfileLabels.pastEducationExperiences.pastEducation_10b
              .value,
            ""
          )
        }}
      />
      {formik.values.pastEducation_10 === "Yes" && (
        <RadioButtonField
          label={
            careerProfileLabels.pastEducationExperiences.pastEducation_10a.label
          }
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.pastEducationExperiences.pastEducation_10a.value
          }
          value={formik.values.pastEducation_10a}
          callback={() => {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_10b
                .value,
              ""
            )
          }}
        />
      )}
      {formik.values.pastEducation_10a === "Yes" && (
        <EditorField
          value={formik.values.pastEducation_10b}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.pastEducationExperiences.pastEducation_10b.value
          }
          label={
            careerProfileLabels.pastEducationExperiences.pastEducation_10b.label
          }
        />
      )}
      <EditorField
        value={formik.values.pastEducation_11}
        onTextChange={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_11.value
        }
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_11.label
        }
      />
      <RadioButtonField
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_12.label
        }
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_12.value
        }
        value={formik.values.pastEducation_12}
        callback={() => {
          formik.setFieldValue(
            careerProfileLabels.pastEducationExperiences.pastEducation_12a
              .value,
            ""
          )
        }}
      />
      {formik.values.pastEducation_12 === "Yes" && (
        <>
          <EditorField
            value={formik.values.pastEducation_12a}
            onTextChange={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_12a
                .value
            }
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_12a
                .label
            }
          />
          <EditorField
            value={formik.values.pastEducation_12b}
            onTextChange={formik.setFieldValue}
            valueName={
              careerProfileLabels.pastEducationExperiences.pastEducation_12b
                .value
            }
            label={
              careerProfileLabels.pastEducationExperiences.pastEducation_12b
                .label
            }
          />
        </>
      )}
      <EditorField
        value={formik.values.pastEducation_13}
        onTextChange={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_13.value
        }
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_13.label
        }
      />
      <PastEducationExperiencesCheckboxForm
        label={
          careerProfileLabels.pastEducationExperiences.pastEducation_14.label
        }
        value={formik.values.pastEducation_14}
        setValue={formik.setFieldValue}
        valueName={
          careerProfileLabels.pastEducationExperiences.pastEducation_14.value
        }
        callback={(value) => {
          if (!value?.other) {
            formik.setFieldValue(
              careerProfileLabels.pastEducationExperiences.pastEducation_14a
                .value,
              ""
            )
          }
        }}
      />
      {formik.values.pastEducation_14.other && (
        <TextField
          size={50}
          label={
            careerProfileLabels.pastEducationExperiences.pastEducation_14a.label
          }
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.pastEducationExperiences.pastEducation_14a.value
          }
          value={formik.values.pastEducation_14a}
        />
      )}
    </>
  )
}
export default PastEducationExperiences
